import { EmbeddedRecordsMixin } from '@ember-data/serializer/rest';
import JSONAPISerializer from '@ember-data/serializer/json-api';

export default JSONAPISerializer.extend(EmbeddedRecordsMixin, {
  isEmbeddedRecordsMixinCompatible: true,

  attrs: {
    completedProjectCount: {serialize: false},
    homeDistance: {serialize: false},
    currentDistance: {serialize: false},
    isVetted: {serialize: false},
    isAdmin: {serialize: false},
    isWhitelisted: {serialize: false},
    canViewReports: {serialize: false},
    inCurrentUsersNetwork: {serialize: false},
    preAssignments: { embedded: 'always' },
  }
});
